import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { ManualExcelExport } from "./use-create-manual-excel-export";

export interface GetManualExcelExportRequest {}

export type GetManualExcelExportResponse = ManualExcelExport;

export interface GetManualExcelExportPathParameter {
  buyerId: number;
  orderSheetSetId: number;
}

export const getManualExcelExportKey: YWRKey<GetManualExcelExportPathParameter> =
  {
    url: ({ buyerId, orderSheetSetId }) =>
      `/buyers/${buyerId}/order-sheet-sets/${orderSheetSetId}/manual-excel-export`,
    method: "get",
  };

export default function useGetManualExcelExport() {
  const fetcher = useFetcher<
    GetManualExcelExportRequest,
    GetManualExcelExportResponse
  >();

  return useYWR(getManualExcelExportKey, fetcher);
}
